import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'
import { sharedPropTypes } from '../propTypes'
import RSSFeedItemFooter from '../components/RSSFeedItemFooter'
import RSSFeedItemCollapsibleBody from '../components/RSSFeedItemCollapsibleBody'
import useNormalizedConfig from '../../hooks/useNormalizedValues'

const useStyles = makeStyles(() => ({
  listItem: {
    borderBottom: '1px solid var(--color-neutral-300)',
    '&:last-child': {
      borderBottom: 'none'
    }
  }
}))
function ListItemVariant ({
  item,
  title: _title,
  summary: _summary,
  body,
  image: _image,
  contentType,
  footer,
  className = 'relative',
  style
}) {
  const classes = useStyles()
  const title = useNormalizedConfig(item, _title)
  const summary = useNormalizedConfig(item, _summary)
  const image = useNormalizedConfig(item, _image)

  return (
    <div
      className={clsx('flex gap-2 p-4 rounded', classes.listItem, className)}
      style={style}
    >
      {image.value && (
        <img
          src={image.value}
          alt={title.value}
          className={clsx('w-32 h-32 object-cover rounded', image.className)}
          style={{ flexShrink: 0, ...image.style }}
        />
      )}
      <div className='flex flex-col gap-2 flex-1'>
        {title.value && (
          <h3 className={clsx('font-size-lg font-weight-600 m-0', title.className)} style={title.style}>
            {title.value}
          </h3>
        )}
        {summary.value && (
          <p className={clsx('font-size-sm text-secondary m-0', summary.className)} style={summary.style}>
            {summary.value}
          </p>
        )}
        <RSSFeedItemCollapsibleBody
          item={item}
          body={body}
          contentType={contentType}
        />
        <RSSFeedItemFooter item={item} config={footer} />
      </div>
    </div>
  )
}

ListItemVariant.propTypes = {
  ...sharedPropTypes
}

export default ListItemVariant
